import {RouteView, PageView} from '../layouts'

export const writeoff = {
    path: '/writeoff',
    name: 'BaseForm',
    component: PageView,
    meta: {title: '核销管理', icon: 'reconciliation', isMenuShow: true,permission:'writeoff'},
    children: [
        {
            path: '/writeoff/coupon',
            name: 'BaseForm',
            component: PageView,
            redirect: '/writeoff/coupon/transferBar',
            // component: () => import('../views/writeoff/transferBar.vue'),
            meta: {title: '卡券管理', icon: 'dollar', isMenuShow: true,permission:'writeoff:cardCoupon'},
            children: [
                {
                    path: '/writeoff/coupon/transferBar',
                    name: 'transferBar',
                    component: () => import('../views/writeoff/transferBar.vue'),
                    meta: {title: '卡券核销', icon: 'dollar', isMenuShow: true,permission:'writeoff:fullWriteoff'},
                },
                {
                    path: '/writeoff/cardCoupon',
                    name: 'BaseForm',
                    component: () => import('../views/writeoff/cardCoupon.vue'),
                    meta: {title: '卡券核销', icon: 'dollar', isMenuShow: true,permission:'writeoff:fullWriteoff'},
                },
                {
                    path: '/writeoff/writeoffHistory',
                    name: 'BaseForm',
                    component: () => import('../views/writeoff/writeoffHistory.vue'),
                    meta: {title: '我的核销历史', icon: 'dollar', isMenuShow: true,permission:'writeoff:writeoffHistory'}
                },
                {
                    path: '/writeoff/fullWriteoff',
                    name: 'BaseForm',
                    component: () => import('../views/writeoff/fullWriteoff.vue'),
                    meta: {title: '全部核销历史', icon: 'dollar', isMenuShow: true,permission:'writeoff:writeoffHistory'}
                },

                {
                    path: '/writeoff/writeoffDetail',
                    name: 'BaseForm',
                    component: () => import('../views/writeoff/writeoffDetail.vue'),
                    meta: {title: '核销详情', icon: 'dollar', isMenuShow: true,permission:'writeoff:writeoffHistory:detail'}
                }
            ]
        }
    ]
}
